<script>
    import { bin, scaleLinear, scaleBand, scaleSymlog, max, mean, extent, groups, rollup, line, curveBasis,curveCatmullRom, scaleOrdinal, descending } from "d3";
    export let eFeatures;
    export let selectionData;
    export let tooltipWidth;
    export let tooltipHeight;
    export let mainDrawColor;
    export let mainSpecialColor;
    export let mainBorderColor;
    export let darkMode;
    export let mainSvgColor;
    // export let mainBgColorControls;
    // export let mainBorderColor;

    let margin = ({top: 30, right: 10, bottom: 10, left: 45});

    $: height = tooltipHeight;
    let bandwidth = 10;
    // let numTicks = 10;
    let radius = 2;

    $: width = tooltipWidth*0.98

    // $: cityHovered = null;

    // filter out cities that have null data in some columns
    // $: aggData = aggData.filter(d=>![d.mobility, d.nightlife, d.active_living, d.community_space, d.health_wellbeing, d.education, d.food_choices].includes(null))

    // $: options = 
	// 	aggData.map(d=> d.CTR_MN_NM).filter(onlyUnique)
    //     .sort(function(a, b) {
	// 			return a.localeCompare(b);
    // });

    // $: options.unshift("all countries")

    // $: selectedCountry = "all countries";
    // $: strokeWidth = selectedCountry==="all countries"?0.5:1.2;
    // $: strokeOpacity = selectedCountry==="all countries"?0.1:0.3;
    // $: countryOpacity = selectedCountry==="all countries"?0.5:strokeOpacity;


    // helper function
    const range = (from, to, step) =>
        [...Array(Math.floor((to - from) / step) + 1)].map((_, i) => from + i * step);

    // options for select
    // let axes = [{label:"transit", value:"mobility"}, {label:"entertainment", value:"entertainment"}, {label:"active L.", value:"active_living"}, {label:"community", value:"community_space"}, {label:"health", value:"health"}, {label:"education", value:"education"}, {label:"food", value:"food_choices"}].reverse()
    let axes = [{label:"mobility", value:"mobility", icon: "directions_bus"}, 
                {label:"nightlife", value:"entertainment", icon: "nightlife"}, 
                {label:"active_living", value:"active_living", icon: "nature_people"}, 
                {label:"community_space", value:"community_space", icon: "groups_3"}, 
                {label:"health_wellbeing", value:"health", icon: "health_and_safety"}, 
                {label:"education", value:"education", icon: "import_contacts"}, 
                {label:"food_choices", value:"food_choices", icon: "restaurant"}].reverse()

    // // CLEAN THIS UP
    // let axesCity = [{label:"transit", value:"mobility"}, {label:"entertainment", value:"nightlife"}, {label:"active L.", value:"active_living"}, {label:"community", value:"community_space"}, {label:"health", value:"health_wellbeing"}, {label:"education", value:"education"}, {label:"food", value:"food_choices"}].reverse()

    let lastAxis = axes.map(d=>d.value)[axes.length-1]
    let firstAxis = axes.map(d=>d.value)[0]

    // console.log(lastAxis)
    
    // let exampleCities = ["Paris, France", "Houston, United States", "Monterrey, Mexico", "Lagos, Nigeria", "New York, United States"]

    // $: highlightCitiesData = aggData.filter(e=>highlightCities.includes(e.UC_NM_CTR))
    // $: console.log("HL cities", highlightCitiesData)

    // let filter = 0
    $: showData = [eFeatures]
    $: selectionData = selectionData.map(d=>({...d, entertainment:d.nightlife, health: d.health_wellbeing}))

    // $: console.log("show", showData)
    // $: console.log("city", selectionData)
                         
    // $: console.log("showData", showData)
    // $: extentAccess = extent(showData, d=>d.accessibility)
    // $: countryCities = 
    // $: highlightCities = selectedCountry==="all countries"?exampleCities:
    //                      showData.length>2?
    //                         [showData.filter(d=>d.accessibility===extentAccess[0])[0].UC_NM_CTR, 
    //                          showData.filter(d=>d.accessibility===extentAccess[1])[0].UC_NM_CTR]:
    //                         [showData.filter(d=>d.accessibility===extentAccess[0])[0].UC_NM_CTR] 

    // $: resetHighlightCities = selectedCountry==="all countries"?exampleCities:
    //                      showData.length>2?
    //                         [showData.filter(d=>d.accessibility===extentAccess[0])[0].UC_NM_CTR, 
    //                          showData.filter(d=>d.accessibility===extentAccess[1])[0].UC_NM_CTR]:
    //                         [showData.filter(d=>d.accessibility===extentAccess[0])[0].UC_NM_CTR] 
    // let data;
    // let extentData;
    // let x;
    // let thresholds;
    // let bins;
    // let y;
    let extentData = [0, 5000]
    // $: console.log(extentData)
    // console.log(extentData)
    $: y = scaleLinear()
            .domain(extentData).nice()
            .range([margin.top, height - margin.bottom])

    $: x = scaleBand()
            .domain(axes.map(d=>d.value))
            .range([margin.left, width - margin.right])

    $: pcLine = line()
            .defined(d => d.value !== null)
            .x(d=>x(d.category))
            .y(d=>y(d.value))
            .curve(curveCatmullRom)

    // $: dataFiltered = aggData.filter(d=>highlightCities.includes(d.UC_NM_CTR))
    // convert data from wide to long
    $: pcData = 
        groups(
            Array.from(
                pivot(
                showData,
                axes.map(d=>d.value),
                [],
                "category",
                "value"
                )
            ), d=>d.category
            )
            .map(d=>{return {
            category:d[0],
            value:d[1][0].value
            }
            }
        )

    $: pcDataCity = 
        groups(
            Array.from(
                pivot(
                selectionData,
                axes.map(d=>d.value),
                [],
                "category",
                "value"
                )
            ), d=>d.category
            )
            .map(d=>{return {
            category:d[0],
            value:d[1][0].value
            }
            }
        )
        // .map(d=>({...d, data: d.data.map(c=>({...c, value:c.value===null?5000:c.value}))}))

    // $: console.log("roll", rollup(pcData.map(d=>d.data).flat(),  v => mean(v, d => d.value), d => d.category))
    // $: console.log("flat", pcData.map(d=>d.data).flat())

    // $: console.log("pc data", pcData)
    

    // $: fifteenMinCities = aggData.filter(d=>d["accessibility"]<=1250)
    // $: fifteenMinCitiesProp = (fifteenMinCities.length/aggData.length)*100


    let yTicks = range(50, 5000, 1230)
    // console.log("ticks", xTicks)


    function walkingTime(meters, short=true, lowerBound=true) {
		const km = meters/1000
		const hours = km/5
		const minutes = km/5 * 60
		const seconds = minutes*60
		// return hours or seconds or minutes
		if (short === true) {
			if (minutes<1) {
			// return seconds.toFixed() + "sec"
			return "1 min"
			} else if (minutes>60){
			return hours.toFixed() + " h"
			} else {
			return minutes.toFixed() + " min"
			}
		} else {
			if (lowerBound===false) {
				if (minutes<1) {
				return "less than 1 minute"
				// return seconds.toFixed() + " seconds"
				} else if (minutes>60){
				return hours.toFixed() + " hours"
				} else {
				return minutes.toFixed() + " minutes"
				}
			} else {
				if (minutes<1) {
				return 1 + " minute"
				} else if (minutes>60){
				return hours.toFixed() + " hour"
				} else {
				return minutes.toFixed() + " minutes"
				}
			}
		}

		// return `${hours}, ${minutes}, ${seconds}`
	}

    function* pivot(data, columns, keepCols, name, value, opts) {
        // const keepCols = columns
        //     ? data.columns.filter(c => !columns.includes(c))
        //     : data.columns;
        for (const col of columns) {
            for (const d of data) {
            const row = {};
            keepCols.forEach(c => {
                row[c] = d[c];
            });
            // TODO, add an option to ignore if fails a truth test to approximate `values_drop_na`
            row[name] = col;
            row[value] = d[col];
            yield row;
            }
        }
    }

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    
</script>

    <div id="chart" style="height:{height};">
        <div class="figTitle" style="width:{width}px; color:{mainDrawColor}">
            <!-- <span>Average walking time to services for cities with more than 100,000 (n={showData.length.toFixed()}) residents across 
                <select 
                style="background-color: {mainBgColorControls}; color:{mainDrawColor}; border-color:{mainBorderColor}"
                bind:value={selectedCountry} 
                on:change="{(e) => console.log(selectedCountry) }"
                >
                    {#each options as option}
                        <option value={option}>
                            {option}
                        </option>
                    {/each}
                </select></span><br><br>
            <span class="figSubtitle"><span style="color:{mainSpecialColor}">Paris</span> has access to all services within a 15 minutes, while many other cities lack in most categories</span><br>
            <span class="figSubSubtitle">👆 hover on a line to highlight a specific city and country</span> -->
        </div>
        <!-- <div>
            {#each axes as axis, i}
                <span class="material-symbols-outlined" style="transform:translate({x(axis.value)-10}px, 5px)">
                    {axis.icon}
                </span>
            {/each}
        </div> -->
        <svg id="shapes" width={width} height={height}>
           
           <!-- axes -->
            {#each axes as axis, i}
                <g class="axis axis--x">
                    <!-- svelte-ignore component-name-lowercase -->
                    <line 
                    class="tick"
                    stroke={mainBorderColor} 
                    stroke-opacity={darkMode===true?0.4:0.2}
                    y1={margin.top} 
                    y2={height-margin.bottom} 
                    x1={x(axis.value)} 
                    x2={x(axis.value)}
                    stroke-width={darkMode===true?0.4:0.2}px/>
                    <!-- {#each axis.label.split(",") as label, i}
                        <text class="tick" text-anchor="middle" fill={mainDrawColor} x={x(axis.value)} y={(margin.top/2)+i*10}>{label}</text>
                    {/each} -->
                    <!-- {#each axis.value.split("_") as label, i} -->
                    <g>
                        <image xlink:href={darkMode===true?"images/"+axis.label+"_dark.png":"images/"+axis.label+"_light.png"} 
                        src={darkMode===true?"images/"+axis.label+"_dark.png":"images/"+axis.label+"_light.png"} width="20" height="20" x={x(axis.value)-10} y={5}/>
                    </g>                    
                    <!-- {/each}  -->
                    <!-- y axis ticks -->
                    {#each yTicks as tick, j} 
                    <g class="tick" opacity="1" transform="translate({x(axis.value)},{y(tick)})">
                        <circle stroke={mainBorderColor} cx="0" cy="0" r="0.5" fill={mainBorderColor} opacity={darkMode===true?0.4:0.2}/>
                        <text fill={mainDrawColor} y="0" dx="-10" text-anchor="end" x="0" font-weight={j===1?700:400} opacity={j===1?1:0.55}>
                            {i===0?walkingTime(tick):""}
                        </text>
                    </g>
                    {/each}
                </g>
            {/each}
            <!-- 15 min line -->
            <!-- svelte-ignore component-name-lowercase -->
            <!-- <line 
            class="tick"
            stroke="red" 
            y1={y(1250)} 
            y2={y(1250)} 
            x1={x(firstAxis)} 
            x2={x(lastAxis)}
            stroke-width="0.5px"/> -->
            <!-- one line for each city -->
            <g class="pcLine">
                <!-- svelte-ignore a11y-mouse-events-have-key-events -->
                <path 
                d={pcLine(pcData)} 
                fill="none" 
                stroke={mainSpecialColor}
                stroke-width={"2px"}
                stroke-opacity={"1"}
                mix-blend-mode="multiply"
                cursor="pointer"
                />
                <!-- <use xlink:href=".highlightedCities"/> -->
            </g>
            <text 
            class="annotation" 
            fill={mainSpecialColor} 
            y={y(pcData.filter(c=>c.category===lastAxis)[0].value)} 
            x={x(lastAxis)+4}
            text-anchor="start"
            >
                this block
            </text>
            <g class="pcLine">
                <!-- svelte-ignore a11y-mouse-events-have-key-events -->
                <path 
                d={pcLine(pcDataCity)} 
                fill="none" 
                stroke={darkMode===true?mainSvgColor:mainSpecialColor}
                stroke-width={"1px"}
                stroke-opacity={darkMode===true?"0.8":"0.3"}
                mix-blend-mode="multiply"
                cursor="pointer"
                />
                <!-- <use xlink:href=".highlightedCities"/> -->
            </g>
            <text 
            class="annotation" 
            fill={darkMode===true?mainSvgColor:mainSpecialColor} 
            opacity={darkMode===true?"0.9":"0.4"}
            y={y(pcDataCity.filter(c=>c.category===lastAxis)[0].value)} 
            x={x(lastAxis)+4}
            text-anchor="start"
            >
                city avg.
            </text>
                <!-- {#if cityHovered===null}
                    {#if highlightCities.includes(data.data[0].UC_NM_CTR)}
                        <text 
                        class="annotation" 
                        fill={mainSpecialColor} 
                        y={y(data.data.filter(c=>c.category===lastAxis)[0].value)} 
                        x={x(lastAxis)+10}
                        text-anchor="start"
                        >
                            {data.data[0].UC_NM_CTR}
                        </text>
                    {/if} 
                {:else if cityHovered.ID_HDC_G0===data.ID_HDC_G0}
                    <text 
                    class="annotation" 
                    fill={mainSpecialColor} 
                    y={y(data.data.filter(c=>c.category===lastAxis)[0].value)} 
                    x={x(lastAxis)+10}
                    text-anchor="start"
                    >
                        {data.data[0].UC_NM_CTR}
                    </text>
                {/if} -->
        </svg>
    </div>


<style>

    .bar {
        /* fill: #bbb; */
    }

    .tick {
        font-size:10px
    }

    .annotation {
        font-size:10px
    }

    .figTitle {
        font-size: 15.3px;
        font-weight: 700;
        text-align: left;
        margin:auto;
    }

    .figSubtitle {
        font-size: 13px;
        font-weight: 400;
        text-align: left;
    }

    .figSubSubtitle {
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        /* opacity: 0.8; */
    }

    #chart {
        /* margin:auto; */
        text-align: center;
        margin:auto;
    }

    #shapes {
        margin:auto;
    }

    select {
      cursor:pointer;
      /* max-width: 215px;
	  min-width: 215px; */
      height:40px;
      /* color:#ccc; */
      font-weight:500;
      font-size: 14px;
      /* text-transform: uppercase; */
	  border-width: 2px;
      /* border-color: #ccc; */
      /* margin-top: 10px; */
	  margin:15px
	  /* transform:translate(18px,10px) */
    }

</style>